export const sanitizeInput = (input) => {
    // Remove leading/trailing whitespace and replace multiple spaces with a single space
    return input.trim().replace(/\s\s+/g, ' ');
};